<template>
  <Documents :page="'edit'" />
</template>

<script>
import Documents from '../../../Shared/Pages/Documents/index.vue'

export default {
  components: {
    Documents
  }
}
</script>
